import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import * as R from "ramda";
import React, {Component} from "react";
import FlexView from "react-flexview";
import ToggleButton from "react-toggle-button";
import Button from "../../../modules/commons/Button";
import Container from "../../../modules/commons/Container";
import SimpleButton from "../../../modules/commons/SimpleButton";
import {defaultTableChange} from "../../../modules/custom/customTable";
import SimpleLoadingOverlay from "../../../modules/popup/SimpleLoadingOverlay";
import SimpleDataTable from "../../../modules/SimpleDataTable";
import SimpleIcon from "../../../modules/SimpleIcon";
import SimpleInput from "../../../modules/SimpleInput";
import Api from "../../../Services/Api";
import {HttpStatus, Status} from "../../common/Constants";
import {
    removeNullFields,
    flattenFormGroupObject,
    getValueFromDDL,
    mapToObjectDDL,
} from "../../common/mapper";
import {formGroup} from "./config";
import MasterUserFilter from "./masterUserFilter";
import MasterUserModifying from "./masterUserModifying";
import ErrorAction from "../../../Redux/ErrorRedux";
import AuthAction from '../../../Redux/AuthRedux'
import {connect} from "react-redux";
import {fetchDataAsync} from "../../../Services/Utils";
import SimpleAlert from "../../../modules/popup/SimpleAlert";

dayjs.extend(customParseFormat);

class MasterUser extends Component {
    tableColumns = [
        {
            name: "",
            label: "No",
            options: {
                customBodyRender: (_, tableMeta) => {
                    const {page, rowsPerPage} = tableMeta.tableState;
                    const rowNumber = page * rowsPerPage + tableMeta.rowIndex + 1;

                    return <>{rowNumber}</>;
                },
            },
        },
        {
            name: "nameEmployee",
            label: "Nama Karyawan",
            options: {
                sort: false,
            },
        },
        {
            name: "noHp",
            label: "No. Telp",
            options: {
                sort: false,
            },
        },
        {
            name: "tanggalMasuk",
            label: "Tgl Masuk",
            options: {
                sort: false,
            },
        },
        {
            name: "alamat",
            label: "Alamat",
            options: {
                sort: false,
            },
        },
        {
            name: "userName",
            label: "Username",
            options: {
                sort: false,
            },
        },
        {
            name: "status",
            label: "Status",
            options: {
                customBodyRender: (val, {rowIndex}) => (
                    <ToggleButton
                        value={val === Status.ACTIVE}
                        onToggle={(value) =>
                            this.handleUpdateStatus(rowIndex, !value ? Status.ACTIVE : Status.INACTIVE)
                        }
                    />
                ),
                sort: false,
            },
        },
        {
            name: "idEmployee",
            label: "Action",
            options: {
                customBodyRender: (val) => {
                    return (
                        <div style={{width: "115px"}}>
                            <Button
                                className="btnAct"
                                style={{marginRight: 15, backgroundColor: "transparent"}}
                                onClick={() => this.handleModifyingVisibility(val, "edit")}
                            >
                                <i
                                    className="fa fa-lw fa-pencil-alt"
                                    style={{
                                        backgroundColor: "transparent",
                                        color: "red",
                                        fontSize: 20,
                                    }}
                                />
                            </Button>
                            {
                            this.props.menuAccess.createAccess && 
                            (
                                <Button
                                    className="btnAct"
                                    style={{marginRight: 15, backgroundColor: "transparent"}}
                                    onClick={() => this.handleModifyingVisibility(val, "correction")}
                                >
                                    <i
                                        className="fa fa-file-signature"
                                        style={{
                                            backgroundColor: "transparent",
                                            color: "red",
                                            fontSize: 20,
                                        }}
                                    />
                                </Button>
                            )
                            }
                            <Button
                                className="btnAct"
                                style={{marginRight: 15, backgroundColor: "transparent"}}
                                onClick={() => this.handleShowAlert(val)}
                            >
                                <SimpleIcon
                                    className="fa fa-trash"
                                    style={{
                                        backgroundColor: "transparent",
                                        color: "red",
                                        fontSize: 20,
                                    }}
                                />
                            </Button>
                        </div>
                    );
                },
                sort: false,
            },
        },
    ];

    constructor(props) {
        super(props);
        this.state = {
            modifyingVisible: false,
            filterVisible: false,
            uploadVisible: false,
            filterData: {},
            selectedData: null,
            loading: false,
            submittedFilterData: {},
            employeeName: null,
            isFetch: false,
            formGroup: {
                ...formGroup,
                password: {value: "nagamas123", mandatory: true},
            },
            kotaOptions: [],
            kecamatanOptions: [],
            kelurahanOptions: [],
            showAlert: false,
            deleteId: null,
            successDelete: false,
            pagination: {
                totalData: 1,
                page: 1,
                limit: 5,
            },
            dataTable: [],
            originData:{
                username: null,
                hakAkses: null
            },
            actionType: null
        };
    }

    componentDidMount = async () => {
        this.handleTriggerLoading();
        await this.fetchData();
        this.handleTriggerLoading();
    }

    componentDidUpdate = async (_, prevState) => {
        if (
            (prevState.pagination.page !== this.state.pagination.page ||
                prevState.pagination.limit !== this.state.pagination.limit) &&
            !this.state.isFetch
        ) {
            this.handleTriggerLoading();
            await this.fetchData(
                this.state.submittedFilterData,
                this.state.pagination.page,
                this.state.pagination.limit
            );
            this.handleTriggerLoading();
        }
    }

    fetchData = async (filter = {}, page = 1, limit = 5) => {
        this.setState((prevValue) => ({...prevValue, isFetch: true}));
        let response = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllEmployee,
            menuName: "Master User",
            setError: this.props.setError,
            args: {
                paramFilters: removeNullFields(filter),
                page,
                limit,
            },
        });
        if (response.ok && response.data.status === HttpStatus.SUCCESS) {
            await this.setState((prevValue) => ({
                ...prevValue,
                dataTable: response.data.data || [],
                pagination: {
                    ...prevValue.pagination,
                    totalData: response.data.totalData,
                    page,
                    limit,
                },
            }));
        }
        this.setState((prevValue) => ({...prevValue, isFetch: false}));
    };

    refetchData = async () => {
        // await this.setState((prevValue) => ({
        //     ...prevValue,
        //     submittedFilterData: {},
        //     employeeName: null,
        //     pagination: {...prevValue.pagination, totalData: 0},
        // }));
        this.fetchData(
            this.state.submittedFilterData,
                this.state.pagination.page,
                this.state.pagination.limit
        );
    };

    handleUpdateStatus = async (index, status) => {
        this.setState((prevValue) => ({...prevValue, loading: true}));
        const selectedData = this.state.dataTable[index];
        const request = {
            employeeId: selectedData.idEmployee,
            status: status,
            username: selectedData.userName,
        };
        let res = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_MASTER_DATA").updateEmployeeStatus,
            menuName: "Master User",
            setError: this.props.setError,
            args: request,
        });
        await this.refetchData();
        this.setState((prevValue) => ({...prevValue, loading: false}));
    };

    handleModifyingVisibility = async (id, actionType = null) => {
        if (!R.isNil(id)) {
            this.handleTriggerLoading();
            let response = await fetchDataAsync({
                asyncFn: Api.create("NAGAMAS_MASTER_DATA").getEmployeeById,
                menuName: "Master User",
                setError: this.props.setError,
                args: id,
            });
            if (response.ok && !R.isNil(response.data.data) && response.data.status === HttpStatus.SUCCESS) {
                const data = response.data.data;
                this.setState((prevState) => ({
                    ...prevState,
                    formGroup: {
                        ...this.state.formGroup,
                        password: {
                            value: "",
                            mandatory: false,
                        },
                    },
                    originData: {
                        hakAkses: data.idUser.roleDto.id,
                        username: data.idUser.username,
                    },
                    selectedData: {
                        ...data,
                        hirarki: data.hirarki.id,
                        idUser: data.idUser.id || "",
                        employeeId: data.id || "",
                        administrationLine: mapToObjectDDL(data.administrationLine, data.administrationLine),
                        ahassLine: mapToObjectDDL(data.ahassLine, data.ahassLine),
                        marketingLine: mapToObjectDDL(data.marketingLine, data.marketingLine),
                        username: data.idUser.username,
                        idrefobj: data.idUser.idrefobj.map((obj) => mapToObjectDDL(obj.namaDealer, obj.kodeCabang)),
                        idrole: mapToObjectDDL(data.idUser.roleDto.roleName, data.idUser.roleDto.id),
                        birthDate: !R.isNil(data.birthDate)
                            ? dayjs(data.birthDate, "DD-MM-YYYY").toDate()
                            : null,
                        tanggalMasuk: !R.isNil(data.tanggalMasuk)
                            ? dayjs(data.tanggalMasuk, "DD-MM-YYYY").toDate()
                            : null,
                        tanggalResign: !R.isNil(data.tanggalResign)
                            ? dayjs(data.tanggalResign, "DD-MM-YYYY").toDate()
                            : null,
                        gender: !R.isNil(data.gender)
                            ? mapToObjectDDL(data.gender.value, data.gender.key)
                            : null,
                        religion: !R.isNil(data.religion)
                            ? mapToObjectDDL(data.religion.value, data.religion.key)
                            : null,
                        province: !R.isNil(data.province)
                            ? mapToObjectDDL(data.province.provinceName, data.province.id)
                            : null,
                        kecamatan: !R.isNil(data.kecamatan)
                            ? mapToObjectDDL(data.kecamatan.kecamatanName, data.kecamatan.id)
                            : null,
                        kabKot: !R.isNil(data.kabKot)
                            ? mapToObjectDDL(data.kabKot.kabKotName, data.kabKot.kabKotId)
                            : null,
                        zipCode: !R.isNil(data.kelurahan)
                            ? {
                                ...mapToObjectDDL(data.kelurahan.zipcode, data.kelurahan.zipcode),
                                kelurahanId: data.kelurahan.id,
                            }
                            : null,
                        ktpPhoto: data.ktpUrlBase64,
                        employeePhoto: data.photoUrlBase64,
                        signPhoto: data.signUrlBase64,
                    },
                    actionType: actionType,
                    modifyingVisible: !prevState.modifyingVisible,
                }));
            }
            this.handleTriggerLoading();
            return;
        }

        this.setState((prevState) => ({
            ...prevState,
            selectedData: null,
            formGroup: {
                ...this.state.formGroup,
                password: {
                    value: "nagamas123",
                    mandatory: true,
                },
            },
            modifyingVisible: !prevState.modifyingVisible,
        }));
    };

    handleTriggerLoading = () => {
        this.setState((prevState) => ({...prevState, loading: !prevState.loading}));
    };

    handleLogOut = () => {
        const payload = {
          logoutLocationLongitude: 0,
          logoutLocationLatitude: 0,
        };
        Api.create("AUTHLOG").logout(payload);
        localStorage.clear("name");
        localStorage.clear("token");
        localStorage.clear("persist:primary");
        localStorage.clear("userId");
    
        this.props.authLogout();
    }

    handleSubmitModifying = async (controls) => {
        this.setState((prevValue) => ({...prevValue, loading: true}));
        const formGroup = flattenFormGroupObject(controls);
        const requestBody = {
            ...formGroup,
            ...this.getAllDDLValue(formGroup),
            hirarki: formGroup.hirarki.id,
            kabKot: getValueFromDDL(formGroup, "kabKot"),
            zipCode: getValueFromDDL(formGroup, "zipCode"),
            idrefobj: !R.isEmpty(formGroup?.idrefobj)
                ? formGroup.idrefobj.map((value) => value.value)
                : [],
            idrole: getValueFromDDL(formGroup, "idrole"),
            ahassLine: getValueFromDDL(formGroup, "ahassLine"),
            marketingLine: getValueFromDDL(formGroup, "marketingLine"),
            administrationLine: getValueFromDDL(formGroup, "administrationLine"),
            birthDate: this.formatDate(formGroup.birthDate),
            tanggalMasuk: this.formatDate(formGroup.tanggalMasuk),
            tanggalResign: this.formatDate(formGroup.tanggalResign),
            kelurahan: !R.isNil(controls.zipCode.value) ? controls.zipCode.value.kelurahanId : "",
        };

        if (!R.isNil(this.state.selectedData) && !requestBody.password) {
            requestBody.password = "";
        }

        let res = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_MASTER_DATA").modifyEmployee,
            menuName: "Master User",
            setError: this.props.setError,
            args: requestBody,
        });
        if (res.ok && res.data.status === HttpStatus.SUCCESS) {
            await this.refetchData();
            if (
              requestBody.idrole !== this.state.originData.hakAkses &&
              this.props.username === this.state.originData.username
            ) {
              this.handleLogOut();
            }
            this.handleModifyingVisibility();
        }
        this.setState((prevValue) => ({...prevValue, loading: false}));
    };

    handleClickDelete = async () => {
        this.setState((prevValue) => ({...prevValue, loading: true, showAlert: false}));
        let {deleteId} = this.state;
        let res = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_MASTER_DATA").deleteEmployee,
            menuName: "Master User",
            setError: this.props.setError,
            args: deleteId,
        });
        if (res.ok && res.data.status === HttpStatus.SUCCESS) {
            this.handleSuccessDelete();
            await this.refetchData();
        }
        this.setState((prevValue) => ({...prevValue, loading: false}));
    };

    handleFilterVisibility = () => {
        this.setState((prevState) => ({
            ...prevState,
            filterVisible: !prevState.filterVisible,
        }));
    };

    handleSubmitFilter = async () => {
        this.setState((prevValue) => ({
            ...prevValue,
            loading: true,
            employeeName: "",
        }));
        const requestBody = removeNullFields({
            ...this.state.filterData,
            ...this.getAllDDLValue(this.state.filterData),
            kabkot: getValueFromDDL(this.state.filterData, "kabkot"),
            birthdate: this.formatDate(this.state.filterData?.birthdate || null),
            tanggalMasuk: this.formatDate(this.state.filterData?.tanggalMasuk || null),
            tanggalResign: this.formatDate(this.state.filterData?.tanggalResign || null),
            status: getValueFromDDL(this.state.filterData, "status"),
        });
        await this.fetchData(requestBody, 1, this.state.pagination.limit);
        this.setState((prevValue) => ({
            ...prevValue,
            loading: false,
            filterVisible: !prevValue.filterVisible,
            submittedFilterData: requestBody,
        }));
    };

    handleChangePage = (tableState) => {
        this.setState((prevValue) => ({
            ...prevValue,
            pagination: {
                ...prevValue.pagination,
                page: tableState.page + 1,
            },
        }));
    };

    handleRowsPerPage = (tableState) => {
        this.setState((prevValue) => ({
            ...prevValue,
            pagination: {
                page: 1,
                totalData: 1,
                limit: tableState.rowsPerPage,
            },
        }));
    };

    handleStateChange = (callback) => {
        this.setState(callback);
    };

    handleSearch = async () => {
        this.setState((prevValue) => ({...prevValue, filterData: {}, loading: true}));
        await this.fetchData({
            name: this.state.employeeName,
        }, 1, this.state.pagination.limit);
        this.setState((prevValue) => ({
            ...prevValue,
            submittedFilterData: {
                name: this.state.employeeName,
            },
            loading: false,
        }));
    };

    getAllDDLValue = (data) => {
        if (!R.isNil(data)) {
            return {
                province: getValueFromDDL(data, "province"),
                kecamatan: getValueFromDDL(data, "kecamatan"),
                gender: getValueFromDDL(data, "gender"),
                religion: getValueFromDDL(data, "religion"),
            };
        }

        return {};
    };

    formatDate = (value) => {
        return value ? dayjs(value).format("DD-MM-YYYY") : "";
    };

    handleShowAlert = (id) => {
        this.setState((prevValue) => ({
            ...prevValue,
            showAlert: !prevValue.showAlert,
            deleteId: id,
        }));
    };

    handleSuccessDelete = () => {
        this.setState((prevValue) => ({...prevValue, successDelete: !prevValue.successDelete}));
    };

    render() {
        return (
            <>
                <Container>
                    <FlexView
                        style={{justifyContent: "space-between"}}
                        vAlignContent="center"
                        className="margin-bottom-20px margin-top-5px"
                    >
                        <FlexView vAlignContent="center">
                            <SimpleInput
                                id="input_text_nama_karyawan"
                                placeholder="Nama Karyawan..."
                                name="employeeName"
                                containerclassname="margin-bottom-5px"
                                value={this.state.employeeName}
                                onChange={({target}) =>
                                    this.setState((prevValue) => ({...prevValue, employeeName: target.value}))
                                }
                            />
                            <SimpleButton onClick={this.handleSearch}>Cari</SimpleButton>
                        </FlexView>
                        <SimpleButton
                            onClick={this.handleFilterVisibility}
                            styles={{width: "unset"}}
                            icon={<i className={"fa fa-qrcode"}></i>}
                        />
                    </FlexView>
                    <SimpleDataTable
                        data={this.state.dataTable}
                        columns={this.tableColumns}
                        toCount={this.state.pagination.totalData}
                        rowsPerPage={this.state.pagination.limit}
                        page={this.state.pagination.page - 1}
                        options={defaultTableChange(this.handleChangePage, this.handleRowsPerPage)}
                        footerAdditionalButtons={
                            <SimpleButton
                                onClick={() => this.handleModifyingVisibility()}
                                text={"Tambah"}
                                icon={<i className={"fa fa-plus margin-right-10px"}></i>}
                            />
                        }
                    />
                </Container>
                {this.state.filterVisible && (
                    <MasterUserFilter
                        state={this.state}
                        onSetState={this.handleStateChange}
                        onClickClose={() => this.handleFilterVisibility()}
                        onSubmit={this.handleSubmitFilter}
                    />
                )}
                {this.state.modifyingVisible && (
                    <MasterUserModifying
                        username={this.props.username}
                        actionType={this.state.actionType}
                        formGroup={this.state.formGroup}
                        initialValues={this.state.selectedData}
                        visible={this.state.modifyingVisible}
                        onClickClose={() => this.handleModifyingVisibility()}
                        onSubmit={this.handleSubmitModifying}
                    />
                )}
                {this.state.loading && <SimpleLoadingOverlay active={this.state.loading}/>}
                {this.state.showAlert && (
                    <SimpleAlert
                        visible={this.state.showAlert}
                        title={"Information"}
                        onClickClose={this.handleShowAlert}
                        content={"Apakah anda yakin ingin menghapus data ini?"}
                        additionalButtons={
                            <FlexView vAlignContent="center" style={{gap: "10px"}}>
                                <SimpleButton onClick={this.handleClickDelete}>Ya</SimpleButton>
                                <SimpleButton onClick={this.handleShowAlert}>
                                    Tidak
                                </SimpleButton>
                            </FlexView>
                        }
                    />
                )}
                {this.state.successDelete && (
                    <SimpleAlert
                        visible={this.state.successDelete}
                        title={"Information"}
                        onClickClose={this.handleSuccessDelete}
                        content={"Data Berhasil Dihapus"}
                        additionalButtons={
                            <FlexView vAlignContent="center" style={{gap: "10px"}}>
                                <SimpleButton onClick={this.handleSuccessDelete}>OK</SimpleButton>
                            </FlexView>
                        }
                    />
                )}
            </>
        );
    }
}

const mapStateToProps = (state) =>{
    return {
        username: state.auth?.user?.username
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        setError: (payload) => dispatch(ErrorAction.setError(payload)),
        authLogout: () => dispatch(AuthAction.authLogout()),
    };
};


export default connect(mapStateToProps, mapDispatchToProps)(MasterUser);
